<template>
  <div class="pt-5 px-4">
    <h3>Convo Tips</h3>
    <v-layout row wrap justify-end>
      <v-btn color="primary" rounded @click="modalCreate">Create</v-btn>
    </v-layout>
    <div>
      <v-data-table :headers="headers" :items="tips" :loading="loading">
        <template #[`item.edit`]="{ item }">
          <td>
            <v-btn color="primary" rounded outlined @click="modalEdit(item)">Edit</v-btn>
          </td>
        </template>
        <template #[`item.delete`]="{ item }">
          <td>
            <v-btn color="primary" rounded @click="deleteTip(item.id)">Delete</v-btn>
          </td>
        </template>
      </v-data-table>
    </div>

    <form-modal
      ref="formModal"
      :selected-tip="selectedTip"
      :on-created="onTipCreated"
      :on-updated="onTipUpdated"
    ></form-modal>
  </div>
</template>

<script>
import { RequestConvoTips } from '../../../../requests/admin/convo-tips';
import FormModal from './FormModal';

export default {
  components: {
    FormModal,
  },

  data() {
    return {
      headers: [
        { text: 'id', value: 'id' },
        { text: 'depth', value: 'depth' },
        { text: 'text', value: 'text' },
        { text: 'created_at', value: 'created_at' },
        { text: 'edit', value: 'edit' },
        { text: 'delete', value: 'delete' },
      ],
      loading: false,
      tips: [],
      selectedTip: undefined,
      createDialog: false,
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      try {
        this.tips = await RequestConvoTips.list();
      } catch (e) {
        alert(e);
      } finally {
        this.loading = false;
      }
    },

    async modalCreate() {
      this.selectedTip = null;

      // Wait for SelectedTip to be reflected in the view.
      await this.$nextTick();

      this.$refs.formModal.openDialog();
    },

    async modalEdit(item) {
      this.selectedTip = item;

      // Wait for SelectedTip to be reflected in the view.
      await this.$nextTick();

      this.$refs.formModal.openDialog();
    },

    async deleteTip(id) {
      const answer = window.confirm('Delete this tips?');
      if (!answer) return;

      await RequestConvoTips.delete(id);
      this.load();
    },

    onTipUpdated(updatedTip) {
      const index = this.tips.findIndex((t) => t.id == updatedTip.id);
      if (index === -1) {
        console.error('Tip not found in list!', updatedTip);
        return;
      }
      this.tips.splice(index, 1, updatedTip);
    },

    onTipCreated(createdTip) {
      this.tips.push(createdTip);
    },
  },
};
</script>
